export const dataTestTransformer = (dataTestId: string): string => {
  return dataTestId?.toLowerCase().replace(/\s+/g, '-') ?? '';
};
